import React, { useState } from 'react';
import styles from './Accordion.module.css';

const Accordion = ({ children, className = '' }) => {
  return (
    <div className={`${styles.accordion} ${className}`}>
      {children}
    </div>
  );
};

export default Accordion;
